import {JetView} from "webix-jet"; // Importing JetView from webix-jet framework
import {devConfig} from "../../../config/config"; // Importing development configuration

/**
 * Class representing the TableJackpotPrizeReportSportBetView.
 * Extends JetView to create a specific view for jackpot prize reports.
 */
export default class TableJackpotPrizeReportSportBetView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService("locale")._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        /**
         * Formats a value as a percentage.
         * @param {number} value - The value to format.
         * @returns {string} The formatted percentage string.
         */
        function percentFormat(value) {
            return webix.i18n.numberFormat(value) + "%"; // Formatting value as percentage
        }

        return {
            rows: [
                {
                     cols: [
                        {
                            id: "datatable", // ID for the datatable
                            view: "datatable", // Webix datatable component
                            scroll: "xy", // Enable both horizontal and vertical scrolling
                            css: "webix_header_border webix_data_border webix_footer_border", // CSS classes for styling
                            columns: [ // Column definitions for the datatable
                                {
                                    id: "date",
                                    header: _("Fecha"), // Localized header for date
                                    width: 200
                                },
                                {
                                    id: "uniqueJackpotId",
                                    header: _("Id del Jackpot"), // Localized header for jackpot ID
                                    width: 350
                                },
                                {
                                    id: "Id",
                                    header: _("Identificación del jugador ganador"), // Localized header for winner ID
                                    width: 350
                                },
                                {
                                    id: "documentType",
                                    header: _("Tipo de documento"), // Localized header for document type
                                    width: 200
                                },
                                {
                                    id: "documentNumber",
                                    header: _("Número de documento"), // Localized header for document number
                                    width: 200
                                },
                                {
                                    id: "leagueOrSportingEvent",
                                    header: _("Liga o evento deportivo"), // Localized header for league or event
                                    width: 200
                                },
                                {
                                    id: "totalAmountWon",
                                    header: _("Monto total ganado"), // Localized header for total amount won
                                    width: 250
                                },
                                {
                                    id: "progressiveSystemModality",
                                    header: _("Modalidad del sistema progresivo"), // Localized header for progressive system modality
                                    width: 200
                                },
                                {
                                    id: "paymentDateAndTime",
                                    header: _("Fecha y hora del pago"), // Localized header for payment date and time
                                    width: 250
                                },
                                {
                                    id: "initialProgressiveAmount",
                                    header: _("Monto inicial del sistema progresivo"), // Localized header for initial progressive amount
                                    width: 250
                                },
                                {
                                    id: "startDateOfTheProgressiveSystem",
                                    header: _("Fecha de inicio del sistema progresivo"), // Localized header for start date of the progressive system
                                    width: 200
                                },
                            ],
                            on: { // Event handlers for the datatable
                                onBeforeLoad: function () {
                                    // Show loading overlay before data load
                                    this.showOverlay("<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>");
                                },
                                onAfterLoad: function () {
                                    // Hide loading overlay after data load
                                    this.hideOverlay();
                                }
                            },
                            ready: function () {
                                // Check if there is no data and show a message
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox);
                                    this.showOverlay("<div class='no-data' style='margin:75px; font-size:18px;'>" + _('No hay datos') + "</div>");
                                }
                            },
                            autowidth: false, // Disable automatic width adjustment
                            math: true, // Enable mathematical operations
                            datafetch: 10, // Number of records to fetch at a time
                            pager: "pagerA" // ID of the pager component
                        }
                    ]
                }
            ]
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the datatable instance
        let url = devConfig.geturlApi() + "Financial/SportsJackpotReport"; // API endpoint for fetching data

        // Event listener for filtering data based on user input
        this.on(this.app, "gamesPerformance:filter", filterData => {
            let object = Object.entries(filterData); // Convert filter data to entries
            let string1 = ""; // Initialize query string for filters

            // Loop through filter data to build query string
            for (let i = 0; i < object.length; i++) {
                if ((typeof object[i][1] !== "object") && (object[i][1] !== "")) {
                    if (object[i][0] == "Datepicker") {
                        let date = object[i][1].split(" - "); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                    } else {
                        if (object[i][0] != "Sort" && object[i][0] != "Dir" && object[i][0] != "Date") {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                        } else {
                            if (object[i][0] == "Date") {
                                let date = object[i][1].replace(" 00:00:00", ""); // Format date
                                string1 = string1 + '&dateFrom=' + date; // Add date to query
                                string1 = string1 + '&dateTo=' + date; // Add date to query
                            }
                        }
                    }
                } else {
                    if ((typeof object[i][1] === "object")) {
                        let object2 = Object.entries(object[i][1]); // Convert nested filter data to entries
                        for (let j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === "start") {
                                    let d = new Date(object2[j][1]); // Create date object for start date
                                    let dateFrom = "dateFrom=" + ((d.getFullYear())) + ":" + ("00" + (d.getMonth() + 1)).slice(-2) + ":" + ("00" + d.getDate()).slice(-2) + " " + ("00" + d.getHours()).slice(-2) + ":" + ("00" + d.getMinutes()).slice(-2) + ":" + ("00" + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to query
                                } else {
                                    if (object2[j][0] === "end") {
                                        let d = new Date(object2[j][1]); // Create date object for end date
                                        let dateTo = "dateTo=" + ((d.getFullYear())) + ":" + ("00" + (d.getMonth() + 1)).slice(-2) + ":" + ("00" + d.getDate()).slice(-2) + " " + ("00" + d.getHours()).slice(-2) + ":" + ("00" + d.getMinutes()).slice(-2) + ":" + ("00" + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            $$("consultDesk").define("disabled", true); // Disable consult desk during loading
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1).then((response) => {
                $$("consultDesk").define("disabled", false); // Re-enable consult desk after loading
            }).catch((e) => {
                $$("consultDesk").define("disabled", false); // Re-enable consult desk on error
            });
            $$("filterPopup").hide(); // Hide filter popup after applying filters
        });

        // Event listener for page change in the pager
        $$("pagerA").attachEvent("onAfterPageChange", function (page) {
            webix.delay(function () {
                if (page != '0') {
                    chargeTable(); // Load data for the new page
                }
            }, '', '', 100);
        });

        // Event listener for resizing the view
        this.on(this.app, "changeSize", filterData => {
            chargeTable(); // Reload table data on size change
        });

        /**
         * Loads data into the grid based on pagination.
         */
        function chargeTable() {
            let size = grid.getPager().config.size; // Get the number of records per page
            let page = grid.getPage(); // Get the current page number
            let first = size * page; // Calculate the starting record index
            let last = (first + size) - 1; // Calculate the ending record index
            grid.load(url + '?start=' + (first) + '&count=' + (last + 1) + filter); // Load data for the current page
        }
    }
}

// FILE DOCUMENTED
